import gql from "graphql-tag";

export const SUBSCRIPTIONS_PER_PRODUCT_QUERY = gql`
  query totalSubscriptionsPerProduct($startDate: Date!, $endDate: Date!) {
    totalSubscriptionsPerProduct(startDate: $startDate, endDate: $endDate) {
      cohort
      engagement {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const SUBSCRIPTION_QUERY = gql`
  query subscriptions($active: Boolean, $product_Type: String, $coachId_Isnull: Boolean, $supportOwnerId_Isnull: Boolean) {
    userSubscriptions(active: $active, product_Type: $product_Type, coachId_Isnull: $coachId_Isnull, supportOwnerId_Isnull: $supportOwnerId_Isnull) {
      edges {
        node {
          id
          startDate
          endDate
          user {
            id
            firstName
            lastName
            email
            userProfile {
              id
              phone
              country {
                code
              }
            }
            productSet {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const PAYFAST_TRANSITION_QUERY = gql`
  query payfastTransitionedSubscriptions {
    payfastTransitionedSubscriptions {
      id
      startDate
      endDate
      user {
        id
        firstName
        lastName
        email
        userProfile {
          id
          phone
          country {
            code
          }
        }
        productSet {
          id
          name
        }
      }
    }
  }
`;
